import { makeServerPut, makeServerPost, makeServerRequest, makeServerDelete } from './util';

const apiPrefix = "api/v1/customers";

export function fetchCustomersSuccess(customers) {
    return {
        type: "FETCH_CUSTOMERS_SUCCESS",
        payload: customers
    };
}

export function fetchCustomersFailure(error) {
    return {
        type: "FETCH_CUSTOMERS_FAILURE",
        payload: error
    };
}

export const fetchCustomers = (key, page) => {
    return (dispatch) => {
        dispatch({type: "FETCH_CUSTOMERS", payload: key});

        if (key) {
            return makeServerRequest(apiPrefix + "?size=20&sort=name,asc&page=" + page + "&name=" + key).then(
                response => dispatch(fetchCustomersSuccess(response.data))
            ).catch(
                error => {
                    dispatch(fetchCustomersFailure(error))
                    throw error
                }
            );
        } else {
            return makeServerRequest(apiPrefix + "?size=20&sort=name,asc&page=" + page).then(
                response => dispatch(fetchCustomersSuccess(response.data))
            ).catch(
                error => {
                    dispatch(fetchCustomersFailure(error))
                    throw error
                }
            );
        }
    };
};

export function fetchCustomerSuccess(customer) {
    return {
        type: "FETCH_CUSTOMER_SUCCESS",
        payload: customer
    };
}

export function fetchCustomerFailure(error) {
    return {
        type: "FETCH_CUSTOMER_FAILURE",
        payload: error,
    };
}

export const newCustomer = () => {
  return {
      type: "NEW_CUSTOMER"
  }
}

export const clearCustomer = () => {
    return {
        type: "CLEAR_CUSTOMER"
    }
}

export const fetchCustomer = (id) => {
    return (dispatch) => {
        dispatch({type: "FETCH_CUSTOMER"});

        return makeServerRequest(apiPrefix + "/" + id).then(
            response => dispatch(fetchCustomerSuccess(response.data))
        ).catch(
            error => {
                dispatch(fetchCustomerFailure(error))
                throw error
            }
        );
    }
};

export function persistCustomerSuccess(customer) {
    return {
        type: "PERSIST_CUSTOMER_SUCCESS",
        payload: customer,
        successMessage: 'Customer saved!'
    };
}

export function persistCustomerFailure(error) {
    return {
        type: "PERSIST_CUSTOMER_FAILURE",
        payload: error,
        errorMessage: error
        
    };
}

export const persistCustomer = (customer) => {
    return (dispatch) => {
        dispatch({type: "PERSIST_CUSTOMER"});

        if(!customer.id) { //If there isn't any ID then we make an POST 
            return makeServerPost(apiPrefix + "/", customer).then (
                response => dispatch(persistCustomerSuccess(response.data))
            ).catch(
                error => dispatch(persistCustomerFailure(error.response.data.errorCode))
            );
        } else {
            return makeServerPut(apiPrefix + "/" + customer.id, customer).then(
                response => dispatch(persistCustomerSuccess(response.data))
            ).catch(
                error => dispatch(persistCustomerFailure(error.response.data.errorCode))
            );
        }
    };
};

export const deleteCustomerSuccess = (customer) => {
    return {
        type: "DELETE_CUSTOMER_SUCCESS",
        payload: customer
    };
};

export const deleteCustomerFailure = (error) => {
    return {
        type: "DELETE_CUSTOMER_FAILURE",
        payload: error
    };
};

export const deleteCustomer = (customerId) => {
    return (dispatch) => {
        dispatch({type: "DELETE_CUSTOMER", payload: customerId});

        return makeServerDelete(apiPrefix + "/" + customerId).then(
            response => dispatch(deleteCustomerSuccess(response.data))
        ).catch(
            error => dispatch(deleteCustomerFailure(error))
        );
    };
};

export function syncCustomerSuccess(result, id) {
    return {
        type: "SYNC_CUSTOMER_SUCCESS",
        payload: result,
        successMessage: "Custom synchronization started for customer " + id
    };
}

export function syncCustomerFailure(error, id) {
    return {
        type: "SYNC_CUSTOMER_FAILURE",
        payload: error,
        errorMessage: error + " (Customer " + id + ")"
    };
}

export const syncCustomer = (id, params = {startTime: '2018-02-20 12:00:00', endTime: '2018-02-28 13:00:00'}) => {
    return (dispatch) => {
        dispatch({type: "SYNC_CUSTOMER"});

        return makeServerPost(apiPrefix + "/" + id + "/synchronize", params).then(
            response => dispatch(syncCustomerSuccess(response.data, id))
        ).catch(
            error => dispatch(syncCustomerFailure(error.response.data.errorCode, id))
        );
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/customers.js